module.exports = __webpack_public_path__ + "media/images/home/main/albums_real-5eee087a658ad929272d3963ae25cf63.png";